import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

export const useAuthRedirect = (redirectPath: string = '/dashboard/transactions') => {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      setIsChecking(false);
      return;
    }

    try {
      const decoded: any = jwtDecode(token);
      const nowInSeconds = Date.now() / 1000;

      // Login sonrasında gelen ama henüz 2FA verify yapılmamış "VerifyCode" token'ları için redirect etme
      const roles =
        decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
      const isVerifyCodeOnly =
        (typeof roles === 'string' && roles === 'VerifyCode') ||
        (Array.isArray(roles) && roles.length === 1 && roles[0] === 'VerifyCode');

      if (isVerifyCodeOnly) {
        setIsChecking(false);
        return;
      }

      if (decoded?.exp && decoded.exp > nowInSeconds) {
        navigate(redirectPath, { replace: true });
      } else {
        setIsChecking(false);
      }
    } catch {
      // Token bozuksa temizleyip normal akışa devam et
      localStorage.removeItem('accessToken');
      setIsChecking(false);
    }
  }, [navigate, redirectPath]);

  return { isChecking };
};

